"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _clsx = _interopRequireDefault(require("clsx"));
var _format = _interopRequireDefault(require("date-fns/format"));
var _isEmpty = _interopRequireDefault(require("lodash/isEmpty"));
var _Container = _interopRequireDefault(require("@material-ui/core/Container"));
var _Typography = _interopRequireDefault(require("@material-ui/core/Typography"));
var _PageContext = _interopRequireDefault(require("@micado-digital/react-ui/context/PageContext"));
var _fireCustomEvent = _interopRequireDefault(require("@micado-digital/react-ui/utils/fireCustomEvent"));
var _useLocals = _interopRequireDefault(require("@micado-digital/react-ui/hooks/useLocals"));
var _Local = _interopRequireDefault(require("@micado-digital/react-ui/components/Local"));
var _CartContext = _interopRequireDefault(require("../../context/CartContext"));
var _ShopContext = _interopRequireDefault(require("../../context/ShopContext"));
var _useOrder = _interopRequireDefault(require("../../Confirmation/hooks/useOrder"));
var _de = _interopRequireDefault(require("../../locals/de.json"));
var _en = _interopRequireDefault(require("../../locals/en.json"));
var _it = _interopRequireDefault(require("../../locals/it.json"));
var _Contact = _interopRequireDefault(require("./Contact"));
var _Confirmation = _interopRequireDefault(require("./Confirmation01.styles"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const Confirmation01 = _ref => {
  let {
    defaultLang = "de"
  } = _ref;
  const {
    shopData
  } = (0, _react.useContext)(_ShopContext.default);
  const [pageData] = (0, _react.useContext)(_PageContext.default);
  const {
    lang: pageDataLang
  } = pageData || {};
  const {
    cart,
    setCart
  } = (0, _react.useContext)(_CartContext.default);
  const order = (0, _useOrder.default)();
  const {
    customerFirstName: firstName,
    lastName,
    number,
    orderDate
  } = order || {};
  const [lang, setLang] = (0, _react.useState)(defaultLang);
  const css = (0, _Confirmation.default)();
  const l = (0, _useLocals.default)({
    lang: lang,
    res: {
      de: _de.default,
      en: _en.default,
      it: _it.default
    }
  });
  (0, _react.useEffect)(() => {
    var _shopData$currency;
    if ((0, _isEmpty.default)(cart) || (0, _isEmpty.default)(order) || (0, _isEmpty.default)(shopData)) return;
    let items = [];
    let totalAmount = 0;
    const cartItems = cart === null || cart === void 0 ? void 0 : cart.items;
    if (!(0, _isEmpty.default)(cartItems)) {
      for (const cartItem of cartItems) {
        const {
          price: {
            amount
          } = {},
          quantity,
          title
        } = cartItem;
        totalAmount += amount;
        items.push({
          item_name: title,
          price: amount,
          quantity
        });
      }
    }
    (0, _fireCustomEvent.default)("purchase", {
      ecommerce: {
        currency: shopData === null || shopData === void 0 || (_shopData$currency = shopData.currency) === null || _shopData$currency === void 0 ? void 0 : _shopData$currency.isoCode,
        transaction_id: order === null || order === void 0 ? void 0 : order.number,
        value: totalAmount,
        items
      }
    });
    localStorage.removeItem("mco-shop-cart");
    setCart({});
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [JSON.stringify(cart), JSON.stringify(order), JSON.stringify(shopData)]);
  (0, _react.useEffect)(() => {
    if (!pageDataLang) return;
    setLang(pageDataLang);
  }, [pageDataLang]);
  const date = (0, _react.useMemo)(() => {
    if (!orderDate) return (0, _format.default)(new Date(), "dd.MM.yyyy");
    return (0, _format.default)(new Date(orderDate), "dd.MM.yyyy");
  }, [orderDate]);
  const time = (0, _react.useMemo)(() => {
    if (!orderDate) return (0, _format.default)(new Date(), "HH:ss");
    return (0, _format.default)(new Date(orderDate), "HH:ss");
  }, [orderDate]);
  if ((0, _isEmpty.default)(order)) {
    return /*#__PURE__*/_react.default.createElement(_Container.default, {
      className: (0, _clsx.default)(css.confirmation, "mco-shop-confirmation"),
      maxWidth: "lg"
    }, /*#__PURE__*/_react.default.createElement(_Typography.default, {
      className: (0, _clsx.default)(css.headline, "mco-shop-confirmation__headline"),
      variant: "h1"
    }, /*#__PURE__*/_react.default.createElement(_Local.default, {
      identifier: "reactShop.confirmation.headlineCancelled",
      l: l
    })), /*#__PURE__*/_react.default.createElement(_Typography.default, {
      className: (0, _clsx.default)(css.text, "mco-shop-confirmation__text"),
      dangerouslySetInnerHTML: {
        __html: l("reactShop.confirmation.text.cancelled", {
          date,
          time
        })
      }
    }), /*#__PURE__*/_react.default.createElement("div", {
      className: css.contact
    }, /*#__PURE__*/_react.default.createElement(_Contact.default, {
      lang: lang
    })));
  }
  return /*#__PURE__*/_react.default.createElement(_Container.default, {
    className: (0, _clsx.default)(css.confirmation, "mco-shop-confirmation"),
    maxWidth: "lg"
  }, firstName && lastName && /*#__PURE__*/_react.default.createElement(_Typography.default, {
    className: (0, _clsx.default)(css.greeting, "mco-shop-confirmation__greeting")
  }, l("reactShop.confirmation.text.greeting", {
    firstName,
    lastName
  }), ","), /*#__PURE__*/_react.default.createElement(_Typography.default, {
    className: (0, _clsx.default)(css.headline, "mco-shop-confirmation__headline"),
    variant: "h1"
  }, /*#__PURE__*/_react.default.createElement(_Local.default, {
    identifier: "reactShop.confirmation.headline",
    l: l
  })), number && /*#__PURE__*/_react.default.createElement(_Typography.default, {
    className: (0, _clsx.default)(css.orderNumber, "mco-shop-confirmation__order-number"),
    dangerouslySetInnerHTML: {
      __html: l("reactShop.confirmation.text.orderNumber", {
        number
      })
    }
  }), /*#__PURE__*/_react.default.createElement(_Typography.default, {
    className: (0, _clsx.default)(css.text, "mco-shop-confirmation__text"),
    dangerouslySetInnerHTML: {
      __html: l("reactShop.confirmation.text.confirm", {
        date,
        time
      })
    }
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: css.contact
  }, /*#__PURE__*/_react.default.createElement(_Contact.default, {
    lang: lang
  })));
};
Confirmation01.propTypes = {
  defaultLang: _propTypes.default.string
};
var _default = exports.default = Confirmation01;